<template lang="pug">
    div
        .title
            slot(name='title')
        form(action='javascript://', v-if='params')
            .form-container(v-if='!homework || homework.editable === undefined || (homework && (homework.editable || usersIds))')
                .row
                    .form-container__column
                        label.form-container__label
                            | {{ $i18n.t('trainer.trainer_gameFormSetting_typeOfExamples') }}
                        .form-container__select
                            cs-multiselect(
                                :multiple='false',
                                :options='itemsTypes',
                                :show-labels='false',
                                :allow-empty='false',
                                v-model="params.itemsType",
                                placeholder="",
                                :custom-label='customLabel',
                            )
                .row
                    .form-container__column
                        label.form-container__label
                            | {{ $i18n.t('trainer.trainer_gamePlayBox_amount') + " " +  $i18n.t(amountLabel) }}
                        .form-container__select
                            cs-multiselect(
                                :multiple='false',
                                :options='difficulties',
                                :show-labels='false',
                                :allow-empty='false',
                                :placeholder="$i18n.t('trainer.trainer_gameFormSetting_selectAmount')",
                                v-model="params.itemsAmount",
                            )
                .row
                    .form-container__column.form-container__column_fixed
                        label.form-container__label.form-container__label_fixed.input-label
                            | {{ $i18n.t('trainer.trainer_gameFormSetting_numOfExamples') }}
                        .form-container__select.form-container__select_short.form-container__select-examples
                            cs-spin-input(
                                :value="params.amountOfExamples",
                                :max="examples",
                                :min="1",
                                @increase="increaseExamples",
                                @decrease="decreaseExamples",
                                @input="params.amountOfExamples = $event",
                                :disabled="params.infinityAmountOfExamples"
                            )
                            .form-container__select-infinity-mode(v-if="gameMode && gameMode === 'free-game'")
                                cs-checkbox#infinityAmountOfExamples.form-container__checkbox(
                                    v-model="params.infinityAmountOfExamples"
                                    :checked="params && params.infinityAmountOfExamples"
                                    :disabled="params && (!!params.timeLimit || !!params.dictation)"
                                )
                                    svg-icon.form-container__svg-icon(name="infinity" :aria-hidden="true" size="big")
                .row
                    .form-container__column
                        label.form-container__label
                            | {{ $i18n.t('trainer.trainer_gameFormSetting_blackWhiteImages') }}
                        .form-container__select
                            cs-checkbox(
                                v-model="params.blackWhiteImages"
                            )
                .row
                    .form-container__column
                        label.form-container__label
                            | {{ $i18n.t('trainer.trainer_gameFormSetting_complication') }}
                        .form-container__select
                            cs-checkbox(
                                :disabled="complicationIsDisabled"
                                v-model="params.complication"
                            )
            divider
            .form-container.form-container_text-centered
                slot(name='parameters', v-if="!($route.params && $route.params.source && $route.params.source === 'homework-template')")
                .help-text
                    slot(name='help')
                template(v-if='!usersIds')
                    .form-container__footer-buttons
                        cs-button.cancel-button(color="blue", pattern="primary-outline", type='button', @click='cancel')
                            | {{ $i18n.t('trainer.trainer_gameFormSetting_dontSave') }}
                        template(v-if="gameMode && gameMode === 'free-game'")
                            cs-button.save-button(color="blue", type='button', :disabled="disableButton", @click='saveGameMode')
                                | {{ $i18n.t('trainer.trainer_gameFormSetting_saveGame') }}
                        template(v-else)
                            cs-button.save-button(color="blue", type='button', :disabled="disableButton", @click='saveGame')
                                | {{ $i18n.t('trainer.trainer_gameFormSetting_saveGame') }}
                template(v-else)
                    .form-container__footer-buttons
                        cs-button.cancel-button(color="blue", pattern="primary-outline", type='button', @click='cancel')
                            | {{ $i18n.t('trainer.trainer_gameFormSetting_dontSave') }}
                        cs-button.save-button(color="blue", type='button', :disabled="disableButton", @click='saveGame')
                            | {{ $i18n.t('trainer.trainer_gameFormSetting_saveGame') }}
</template>

<script>
    import { cloneDeep, find } from 'lodash';
    import { mapState } from 'vuex';

    import GamesList from '../GamesList.vue';
    import GameFormMixin from '../../../utils/trainer/GameFormMixin';
    import { getInitParameters } from '../../../utils/trainer/getInitParameters';
    import TrainerGames from '../../../config/trainer.json';
    import LonerBonusGamesApi from '../../../api/games/lonerBonusGamesApi';

    const MIN_ELEMENTS_BY_TYPE = {
        3: 4,
        2: 5,
    };

    export default {
        components: {
            GamesList,
        },
        props: ['slug', 'courseType', 'id', 'usersIds', 'homeworkId', 'gameMode', 'levelAnswerDuration'],
        mixins: [GameFormMixin],
        data() {
            return {
                params: {
                    infinityAmountOfExamples: false,
                    amountOfExamples: 1,
                    itemsType: {
                        name: 'couples',
                        value: '2',
                        label: 'trainer.trainer_items_type_couples',
                    },
                    itemsAmount: 5,
                    complication: false,
                    blackWhiteImages: false,
                },
                itemsTypes: [
                    {
                        name: 'couples',
                        value: '2',
                        label: 'trainer.trainer_items_type_couples',
                    },
                    {
                        name: 'triads',
                        value: '3',
                        label: 'trainer.trainer_items_type_triads',
                    },
                ],
                examples: 15,
                maxDifficulty: 5,
            };
        },
        mounted() {
            this.getMaxDifficulty();
            if (this.gameMode === 'free-game') {
                if (this.game && this.game.slug === this.slug) {
                    this.params = cloneDeep(this.game);
                } else if (this.gamesParameters?.[this.slug]) {
                    this.$set(
                        this,
                        'params',
                        getInitParameters({
                            slug: this.slug,
                            parameters: {
                                default: cloneDeep(this.gamesParameters[this.slug]),
                            },
                        })
                    );
                } else {
                    const courseTypeKebab = _.kebabCase(this.courseType);
                    this.params = cloneDeep(
                        TrainerGames.games.find(
                            ({ slug, courseType }) => slug === this.slug && courseType === courseTypeKebab
                        ).parameters.default
                    );
                }
                this.selectedDifficult = find(this.difficult, { name: this.params.difficult });
            } else {
                this.setInitParams(this.getKey(this.usersIds));
            }
            this.params.slug = this.slug;
            if (this.homework && this.homework.coursesType) {
                this.params.courseType = this.homework.coursesType;
            }
        },
        computed: {
            ...mapState({
                homework: state => state.trainer.homework,
                homeworkCopy: state => state.trainer.homeworkCopy,
                gamesParameters: state => state.trainer.gamesParameters,
                user: state => state.auth.user,
                levels: state => {
                    return state.olympiad.intermediateStage && state.olympiad.intermediateStage.levels;
                },
                battleLevels: state => {
                    return state.battle.intermediateBattleStage && state.battle.intermediateBattleStage.levels;
                },
                game: state => state.trainer.game,
            }),
            complicationIsDisabled() {
                return (
                    (this.params.amountOfExamples < 2 && !this.params.infinityAmountOfExamples) ||
                    this.params.itemsAmount === 18
                );
            },
            amountLabel() {
                return +this.params.itemsType.value === 2
                    ? 'trainer.trainer_gamePlayBox_couples'
                    : 'trainer.trainer_gamePlayBox_triads';
            },
            disableButton() {
                return !this.params.itemsType || !this.params.itemsAmount;
            },
            isOlympiad() {
                return !this.gameMode && !this.homework && this.levels;
            },
            isBattle() {
                return !this.gameMode && !this.homework && this.battleLevels;
            },
            difficulties() {
                const result = [];
                const min = MIN_ELEMENTS_BY_TYPE[this.params.itemsType.value]
                for (let i = min; i <= this.maxDifficulty; i++) {
                    result.push(i);
                }
                return result;
            },
        },
        watch: {
            'params.amountOfExamples': {
                handler(val) {
                    if (val === 1 && this.params.complication) {
                        this.params.complication = false;
                    }
                },
                deep: true,
            },
            'params.itemsAmount': {
                handler(val) {
                    if (val === 18 && this.params.complication) {
                        this.params.complication = false;
                    }
                },
                deep: true,
            },
            'params.itemsType': {
                handler(val) {
                    if (val.value === '2' && this.params.itemsAmount < 5) {
                        this.params.itemsAmount = 5;
                    }
                },
                deep: true,
            },
        },
        methods: {
            decreaseExamples() {
                if (this.params.amountOfExamples !== 1) {
                    this.params.amountOfExamples -= 1;
                }
            },
            increaseExamples() {
                if (this.params.amountOfExamples !== this.examples) {
                    this.params.amountOfExamples += 1;
                }
            },
            customLabel({ label }) {
                return this.$i18n.t(label);
            },
            async getMaxDifficulty() {
                const minImages = await LonerBonusGamesApi.getMinImages();
                this.maxDifficulty = minImages - 1;
            },
        },
    };
</script>

<style lang="scss" scoped>
    .title {
        display: flex;
        justify-content: center;
        font-weight: 500;
        font-size: 22px;
        line-height: 26px;
        text-align: center;
        margin-bottom: 25px;
    }
    .row {
        margin: 0;
    }
    .form-container {
        width: 100%;
        max-width: 820px;
        margin: 0 auto;
    }
    .form-container__checkbox {
        margin-left: 30px;
    }
    .form-container__select-infinity-mode {
        display: flex;
        align-items: center;
        margin-top: 20px;
        @media screen and (min-width: 700px) {
            margin-top: 0;
        }
    }
    .form-container__select_short {
        display: flex;
        align-items: center;
    }
    .form-container__column_fixed {
        @media screen and (max-width: 767px) {
            flex-direction: row;
        }
        @media screen and (max-width: 575px) {
            flex-direction: row;
        }
    }
    .form-container__select-examples {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        @media screen and (min-width: 700px) {
            flex-direction: row;
            align-items: center;
        }
    }
    .form-container_text-centered {
        text-align: center;
    }
    .form-container__column {
        width: 100%;
        display: flex;
        align-items: center;
        margin-bottom: 30px;
        @media screen and (max-width: 767px) {
            flex-direction: column;
        }
    }
    .form-container__column_centered {
        justify-content: center;
    }
    .form-container__label {
        margin-right: 20px;
        width: 30%;
        text-align: right;
        @media screen and (max-width: 767px) {
            width: 100%;
            margin: 0 0 10px 0;
            text-align: left;
        }
    }
    .form-container__select {
        width: 100%;
        max-width: 300px;
        @media screen and (max-width: 767px) {
            max-width: none;
        }
    }
    .form-container__select_fixed-width {
        max-width: 518px;
    }
    .form-container__footer-buttons {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 20px;
        @media screen and (max-width: 767px) {
            flex-direction: column;
        }
    }
    .cancel-button {
        width: 200px;
    }
    .save-button {
        width: 200px;
        margin-left: 20px;
        @media screen and (max-width: 767px) {
            margin: 20px 0 0 0;
        }
    }
    .help-text {
        color: #888888;
    }
    .image-input__link {
        cursor: pointer;
        margin-right: 20px;
        font-size: 16px;
        line-height: 19px;
        color: $hsl-color-blue-56;
        text-decoration: underline;
        &:hover {
            color: $hsl-color-blue-56;
            text-decoration: none;
        }
    }
    .image-container {
        cursor: pointer;
        margin: 10px;
        background: #ffffff;
        border: 2px solid #e6e6f8;
        box-sizing: border-box;
        border-radius: 10px;
        padding: 5px;
        @media screen and (max-width: 767px) {
            margin: 8px;
        }
        @media screen and (max-width: 575px) {
            margin: 5px;
        }
        img {
            width: 120px;
            height: 120px;
            @media screen and (max-width: 575px) {
                width: 70px;
                height: 70px;
            }
        }
        &_selected {
            border-color: #2187ff;
        }
    }
    .images-wrapper {
        display: flex;
        justify-content: center;
        flex-wrap: wrap;
        width: 462px;
        @media screen and (max-width: 575px) {
            width: 188px;
        }
    }
    .image-selector__text {
        margin-top: 20px;
    }
    .image-slider {
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .image-slider__circle {
        width: 10px;
        height: 10px;
        background: #e6e6f8;
        margin: 5px;
        border-radius: 50%;
        &_active {
            background: #2187ff;
        }
    }
    .image-slider__arrow {
        color: #2187ff;
        &_disabled {
            pointer-events: none;
            color: $hsl-color-gray-53;
        }
    }
</style>
